import * as React from 'react';
import { useAccount, State } from '@grandvisionhq/auth';
import { useDispatch, useSelector, statusUnavailable, statusUninit, unavailableState } from '@grandvisionhq/state';
import { fetchList } from '../AddressBook/actions.js';
import { getAddressBookList } from '../AddressBook/selectors.js';

const useAddressBookList = ({ skip  } = {})=>{
    const dispatch = useDispatch();
    const state = useAccount();
    const addressBook = useSelector(getAddressBookList);
    React.useEffect(()=>{
        if (!skip && !statusUnavailable(addressBook) && statusUninit(addressBook) && state === State.AuthState.LoggedIn) {
            dispatch(fetchList());
        }
    }, [
        skip,
        state,
        dispatch,
        addressBook
    ]);
    if (skip || state === State.AuthState.LoggedOut) {
        return unavailableState();
    }
    return addressBook;
};

export { useAddressBookList };
//# sourceMappingURL=use-address-book-list.js.map
